import React, { useState } from "react";
import { sendContactMessage } from "../services/apiContactUs";
import Button from "../ui/Button.jsx";
import Heading from "../ui/Heading.jsx";

function Contact() {
    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                return setStatus("Please enter a valid email.");
            }

            if (formData.message.length < 10) {
                return setStatus("Message must be at least 10 characters.");
            }
            await sendContactMessage(formData);
            setStatus("Message sent! 🎉");
            setFormData({ name: "", email: "", message: "" });
        } catch (err) {
            console.error(err);
            setStatus("Something went wrong 😢");
        }
    };

    return (
        <div className="pt-10 mx-auto w-full max-w-2xl px-4">
            <Heading className="text-center font-bold mb-4">
                Contact Us
            </Heading>
            <p className={"text-center text-gray-600"}>
                Got the goss on an upcoming party we should know about?
            </p>
            <p className="text-center text-gray-600">
                Or have some feedback on making{" "}
                <strong>UnicorNation</strong>{" "}
                even better?
            </p>

            {/*<p className={"text-center text-gray-600 mb-6"}>*/}
            {/*    Drop us a message, we’d love to hear from you!*/}
            {/*</p>*/}

            <p className="text-center text-gray-600 mt-2">
                Email us directly at{" "}
                <a
                    href="mailto:contact@unicornation.com.au?subject=Unicornation%20Feedback"
                    className="font-medium text-pink-500 hover:text-pink-600 underline"
                >
                    contact@unicornation.com.au
                </a>
            </p>


            {/*<form onSubmit={handleSubmit} className="space-y-4">*/}
            {/*    <input  name="name" value={formData.name} onChange={handleChange} */}
            {/*           placeholder="Your name" required*/}
            {/*           className="w-full p-2 border rounded-md"/>*/}
            {/*    <input name="email" value={formData.email} onChange={handleChange} */}
            {/*           placeholder="Your email" type="email"*/}
            {/*           required className="w-full p-2 border rounded-md"/>*/}
            {/*    <textarea name="message" value={formData.message} onChange={handleChange} */}
            {/*              placeholder="Your message"*/}
            {/*              rows="5" required className="w-full p-2 border */}
            {/*              rounded-md "/>*/}
            {/*    <Button size="small" type="submit" className="*/}
            {/*        p-2 rounded-md font-semibold">Send</Button>*/}
            {/*</form>*/}
            {/*{status && <p className="text-center mt-4">{status}</p>}*/}
        </div>
    );
}

export default Contact;
